// Enums
export enum ReferralStatus {
  PENDING = 'pending',
  REGISTERED = 'registered',
  ALBUM_CREATED = 'album_created',
  INTERACTED = 'interacted',
  SUCCESSFUL = 'successful',
  EXPIRED = 'expired'
}

export enum RewardType {
  WATERMARK_REMOVAL = 'watermark_removal',
  FREE_ALBUM = 'free_album',
  DISCOUNT_ELIGIBILITY = 'discount_eligibility'
}

export type ShareMethod = 'copy' | 'email' | 'facebook' | 'twitter';

// Core Data Types
export interface ReferralData {
  id: number;
  referrer_id: number;
  referred_user_id?: number;
  status: ReferralStatus;
  success_criteria_met_at?: string;
  created_at: string;
  updated_at: string;
  referred_user?: {
    id: number;
    name: string;
    email: string;
  };
}

export interface ReferralReward {
  id: number;
  type: RewardType;
  description: string;
  value: any;
  expiresAt?: Date;
  isActive: boolean;
}

export interface ReferralStats {
  totalReferrals: number;
  successfulReferrals: number;
  totalRewards: number;
  activeRewardsCount: number;
}

// API Response Types
export interface ReferralDashboardResponse {
  success: boolean;
  data: {
    statistics: {
      total_referrals: number;
      successful_referrals: number;
      total_rewards: number;
      active_rewards_count: number;
    };
    active_rewards: ReferralRewardData[];
  };
}

export interface ReferralCodeResponse {
  success: boolean;
  data: {
    referral_code: string;
    referral_link: string;
  };
}

export interface ReferralHistoryResponse {
  success: boolean;
  data: ReferralData[];
  meta: {
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
  };
}

export interface ReferralRewardData {
  id: number;
  referral_id: number;
  type: RewardType;
  description: string;
  value: any;
  expires_at?: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

// Component Props Types
export interface ReferralStatsProps {
  stats: ReferralStats;
  loading?: boolean;
}

export interface ReferralCodeCardProps {
  code: string;
  link: string;
  onUpdateCode: (newCode: string) => Promise<void>;
  onShare: (method: ShareMethod) => void;
  loading?: boolean;
}

export interface ShareModalProps {
  visible: boolean;
  referralLink: string;
  onClose: () => void;
  onShare: (method: ShareMethod) => void;
}

export interface RecentHistoryProps {
  referrals: ReferralData[];
  loading?: boolean;
}

export interface ActiveRewardsProps {
  rewards: ReferralReward[];
  loading?: boolean;
}

export interface RewardCardProps {
  reward: ReferralReward;
}

// API Request Types
export interface UpdateReferralCodeRequest {
  referral_code: string;
}
